import type { InputHTMLAttributes } from 'react';

import { cn } from '../../lib/cn';

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        'h-9 w-full rounded border border-border bg-card px-3 text-sm text-fg placeholder:text-muted-fg',
        'focus:outline-none focus:ring-2 focus:ring-primary/40',
        className,
      )}
      {...props}
    />
  );
}
